module.exports = __webpack_public_path__ + "img/right-info-close01.4e67e3a0.png";